import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { Classes } from "@/components/landing/Classes";
import { Countries } from "@/components/landing/Countries";
import { Teacher } from "@/components/landing/Teacher";
import { Gallery } from "@/components/landing/Gallery";
import { Approach } from "@/components/landing/Approach";
import { Steps } from "@/components/landing/Steps";
import { About } from "@/components/landing/About";
import { Contact } from "@/components/landing/Contact";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

const Landing = () => (
    <div className="min-h-screen bg-ground-deep text-ink">
        <div className="grain-overlay" />
        <Navbar />
        <main>
            <Hero />
            <TrustStrip />
            <Classes />
            <Countries />
            <Teacher />
            <Gallery />
            <Approach />
            <Steps />
            <About />
            <Contact />
            <Faq />
        </main>
        <Footer />
        <WhatsAppFloat />
    </div>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
